import "./theme.ts";
import "./x-posts.ts";
if (import.meta.hot) import.meta.hot.accept();
